<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Book-Title--Front-Matter-"><a id="page_i"></a>Sentenced to Prism</p>
<p class="ORIM-Book-Subtitle--Front-Matter-">Humanx Commonwealth</p>
<p class="ORIM-Author-Name--Front-Matter-">Alan Dean Foster</p>
<div class="img_container1">
<img alt="image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?6abe0740